/**
 * This module exposes angular dependency injection into non-angular code, to be used in es6 module environments.
 */
let services = {};

angular
  .module("highbond.storyboard.glue", ["acl.common.localize", "acl.common.config", "acl.visualizer.model.accessControl"]) // Ensure AccessChecker module is included
  .run(function(Localize, AppConfig, AccessChecker) { // Inject AccessChecker
    services.Localize = Localize;
    services.AppConfig = AppConfig;
    services.AccessChecker = AccessChecker; // Expose AccessChecker
  });

module.exports = services;
